module.exports = __webpack_public_path__ + "static/media/imaflora_recorte.6f2afc18.png";